export const LANGUAGES_AVAILABLE = ['en-CA', 'fr-CA', 'en-US', 'es-MX', 'ar'];
